// extracted by mini-css-extract-plugin
export default {"tupacGrid":"oi-z","tupacHeader":"pi-z","tupacHeader2":"qi-z","tupacMenu":"ri-z","tupacMenu2":"si-z","tupacMain":"ti-z","tupacMain2":"ui-z"};